module.exports = __webpack_public_path__ + "img/9_26.97c441ec.png";